import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

import { CardDetails } from '../models/card-details';

@Component({
  selector: 'app-card-container',
  templateUrl: './card-container.component.html',
  styleUrls: ['./card-container.component.scss']
})
export class CardContainerComponent implements OnInit, OnDestroy {
  @Input() cards: CardDetails[];
  @Output() clicked = new EventEmitter<CardDetails>();

  constructor() {}

  ngOnInit(): void {}

  cardClicked(card: CardDetails): void {
    this.clicked.emit(card);
  }

  ngOnDestroy() {}
}
